// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"29":"css/bootstrap-4-utilities","170":"css/app","566":"css/nova-sticky-actions","791":"css/nifty","794":"css/theme-ocean","887":"css/booking"}[chunkId] + ".css";
};